import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { AppRouteConfig } from '@routes/route';

export const solversRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.solvers.root,
    lazyImport: () => import('../../domains/protected/solvers/SolversRoute.tsx'),
    requiresAuth: true,
    resourceId: 'solver',
    children: [
      {
        index: true,
        lazyImport: () =>
          import('../../domains/protected/solvers/pages/solvers-list/SolversListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.solvers.new,
        lazyImport: () =>
          import('../../domains/protected/solvers/pages/solver-details/SolverDetailsRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.solvers.details,
        lazyImport: () =>
          import('../../domains/protected/solvers/pages/solver-details/SolverDetailsRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.solvers.historyDetails,
        lazyImport: () =>
          import('../../domains/protected/solvers/pages/solver-details/solver-history/ViewHistoryItemRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'history'
        }
      }
    ]
  }
];
